import { IPCRCrewMember } from '../../../features/crew/store/crew.types'
import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'

export const addPreceptorStudentField = (pcr: any): IPcr => {
  try {
    if (pcr.crew && Array.isArray(pcr.crew)) {
      pcr.crew.forEach((crewMember: IPCRCrewMember) => {
        if (crewMember && crewMember.preceptorStudent === undefined) {
          crewMember.preceptorStudent = null
        }
      })
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addPreceptorStudentField: ${error}`)
    throw error
  }
}
